export default __webpack_public_path__ + "static/media/style-choice.c9963995.png";